import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const ExternalLink = ({ href, children, ...props }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </a>
);

const Section = ({ id, title, children }) => (
  <section className="home-section" aria-labelledby={id}>
    <h2 id={id} className="home-section-label">{title}</h2>
    <div className="home-section-content">{children}</div>
  </section>
);

const PersonalWebsite = () => (
  <div className="home-page">
    <a href="#main-content" className="home-skip-link">Skip to content</a>
    <div className="home-shell">
      <header className="home-header">
        <div className="home-topline">
          <span>Products, strategy & leadership</span>
          <a href="mailto:ted.marchildon@gmail.com">Get in touch <span aria-hidden="true">↗</span></a>
        </div>
        <div className="home-intro">
          <div>
            <h1>Teddy Marchildon</h1>
            <p className="home-statement">Building products.<br />Growing teams.</p>
            <p className="home-summary">Leading teams and company-wide initiatives at Check. Previously Meta.<br className="home-desktop-break" /> I also build independent software.</p>
            <nav className="home-socials" aria-label="Social profiles">
              <ExternalLink href="https://www.linkedin.com/in/teddy-marchildon/">LinkedIn <span aria-hidden="true">↗</span></ExternalLink>
              <ExternalLink href="https://substack.com/@teddymarchildon">Substack <span aria-hidden="true">↗</span></ExternalLink>
              <ExternalLink href="https://x.com/TeddyMarchildon">X / Twitter <span aria-hidden="true">↗</span></ExternalLink>
            </nav>
          </div>
          <img src="/profile-photo.png" alt="Teddy Marchildon" width="112" height="112" className="home-portrait" />
        </div>
      </header>

      <main id="main-content" tabIndex={-1}>
        <Section id="experience" title="Leadership & experience">
          <article className="home-experience">
            <div className="home-item-heading">
              <h3><ExternalLink href="https://www.checkhq.com/">Check Technologies <span aria-hidden="true">↗</span></ExternalLink></h3>
              <span className="home-date">2021–present</span>
            </div>
            <p className="home-role">R&D Director</p>
            <p>Member of Check’s leadership team, leading planning and execution for company-wide strategic initiatives. Grew from building products to leading teams and R&D as Check scaled.</p>
            <p className="home-context">Joined when Check ran payroll for fewer than 100 businesses. During my time here, Check has grown to serve tens of thousands of businesses, has paid over a million people, and moves tens of billions of dollars annually.</p>
          </article>
          <article className="home-experience">
            <div className="home-item-heading">
              <h3>Meta</h3>
              <span className="home-date">2019–2021</span>
            </div>
            <p className="home-role">Product building</p>
            <p>Shipped Profile features used by 2B+ people, including profile photos, cover photos, and memorialization. Built tooling to detect regressions in global deployment pipelines.</p>
          </article>
        </Section>

        <Section id="projects" title="Selected projects">
          <p className="home-section-note">Independent products, built and shipped.</p>
          <article className="home-project">
            <div className="home-item-heading">
              <h3><ExternalLink href="https://www.govsrc.com/">GovSource <span aria-hidden="true">↗</span></ExternalLink></h3>
              <span className="home-tag">Web</span>
            </div>
            <p>Founded, built, and operate a media company that makes complex legislation understandable. Approximately 400 visitors each week.</p>
          </article>
          <article className="home-project">
            <div className="home-item-heading">
              <h3><Link to="/rowly">Rowly <span aria-hidden="true">↗</span></Link></h3>
              <span className="home-tag">macOS</span>
            </div>
            <p>Built and shipped a fast, local-first CSV editor for everyday data work.</p>
            <div className="home-project-links">
              <ExternalLink href="https://apps.apple.com/us/app/easy-csv-fast-csv-editing/id6759234968?mt=12">Mac App Store <span aria-hidden="true">↗</span></ExternalLink>
              <ExternalLink href="https://github.com/teddymarchildon/easy-csv">Source code <span aria-hidden="true">↗</span></ExternalLink>
            </div>
          </article>
          <article className="home-project">
            <div className="home-item-heading">
              <h3><Link to="/build-better">Build Better <span aria-hidden="true">↗</span></Link></h3>
              <span className="home-tag">iOS</span>
            </div>
            <p>Designed and built daily professional-development prompts with reminders, favorites, and personalized categories.</p>
          </article>
        </Section>

        <Section id="background" title="Background">
          <div className="home-background">
            <p><strong>Duke University</strong><span className="home-date">2019</span></p>
            <p>B.S. Computer Science, minor in Statistics.</p>
            <ul className="home-earlier">
              <li><strong>Meta:</strong> Built tooling for business Pages before joining full-time.</li>
              <li><strong>Barclays:</strong> Built a real-time stock quote analyzer for equity trading.</li>
              <li><strong>WillowTree:</strong> Shipped production iOS and Android apps.</li>
            </ul>
          </div>
        </Section>
      </main>

      <footer className="home-footer">
        <p>Let’s build something that matters.</p>
        <a className="home-contact" href="mailto:ted.marchildon@gmail.com">Get in touch <span aria-hidden="true">↗</span></a>
        <div className="home-footer-meta">
          <span>© {new Date().getFullYear()} Teddy Marchildon</span>
          <span>Products. Teams. Progress.</span>
        </div>
      </footer>
    </div>
  </div>
);

export default PersonalWebsite;
